export default __webpack_public_path__ + "static/media/6daa04c8fb7598604aefe9c76cdf8621.png";